<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false">
    <path d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"/>
  </svg>
</template>

<script>
export default {
  name: 'ChevronUpIcon',
  props: {
    size: {
      type: [String, Number],
      default: 24
    }
  }
}
</script>
